var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIcons5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39672 9.96384C8.30505 9.95467 8.19505 9.95467 8.09422 9.96384C5.91255 9.89051 4.18005 8.10301 4.18005 5.90301C4.18005 3.65717 5.99505 1.83301 8.25005 1.83301C10.4959 1.83301 12.3201 3.65717 12.3201 5.90301C12.3109 8.10301 10.5784 9.89051 8.39672 9.96384Z",
    stroke: "#15194B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0423 3.66699C16.8206 3.66699 18.2506 5.10616 18.2506 6.87533C18.2506 8.60783 16.8756 10.0195 15.1615 10.0837C15.0881 10.0745 15.0056 10.0745 14.9231 10.0837",
    stroke: "#15194B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81353 13.347C1.5952 14.832 1.5952 17.252 3.81353 18.7278C6.33436 20.4145 10.4685 20.4145 12.9894 18.7278C15.2077 17.2428 15.2077 14.8228 12.9894 13.347C10.4777 11.6695 6.34353 11.6695 3.81353 13.347Z",
    stroke: "#15194B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8115 18.333C17.4715 18.1955 18.0949 17.9297 18.6082 17.5355C20.0382 16.463 20.0382 14.6938 18.6082 13.6213C18.104 13.2363 17.4899 12.9797 16.839 12.833",
    stroke: "#15194B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcons5);
export default __webpack_public_path__ + "static/media/menu-icons-5.d3a32b1b20ca8cb1981fe0a28a406f12.svg";
export { ForwardRef as ReactComponent };